import { IntegrationOrgConfig } from '@liquid-state/pephealth-client';

export type ILoadOrgConfig = ReturnType<typeof loadOrgConfig>;
export const loadOrgConfig = (integrationSlug: string, organisationId?: string) => ({
  type: 'integrations/load-org-config' as const,
  payload: {
    integrationSlug,
    organisationId,
  },
});

export type ILoadOrgConfigSuccess = ReturnType<typeof loadOrgConfigSuccess>;
export const loadOrgConfigSuccess = (
  integrationSlug: string,
  config: IntegrationOrgConfig,
  organisationId?: string,
) => ({
  type: 'integrations/load-org-config-success' as const,
  payload: {
    integrationSlug,
    config,
    organisationId,
  },
});

export type ILoadOrgConfigNotConfigured = ReturnType<typeof loadOrgConfigNotConfigured>;
export const loadOrgConfigNotConfigured = (integrationSlug: string, organisationId?: string) => ({
  type: 'integrations/load-org-config-not-configured' as const,
  payload: { integrationSlug, organisationId },
});

export type ILoadOrgConfigFailure = ReturnType<typeof loadOrgConfigFailure>;
export const loadOrgConfigFailure = (
  integrationSlug: string,
  organisationId?: string,
  status?: number,
  errorCode?: string,
) => ({
  type: 'integrations/load-org-config-failure' as const,
  payload: { integrationSlug, organisationId, status, errorCode },
});

export type ICreateOrgConfig = ReturnType<typeof createOrgConfig>;
export const createOrgConfig = (
  integrationSlug: string,
  configData: object,
  organisationId?: string,
) => ({
  type: 'integrations/create-org-config' as const,
  payload: {
    integrationSlug,
    configData,
    organisationId,
  },
});

export type ICreateOrgConfigSuccess = ReturnType<typeof createOrgConfigSuccess>;
export const createOrgConfigSuccess = (
  integrationSlug: string,
  config: IntegrationOrgConfig,
  organisationId?: string,
) => ({
  type: 'integrations/create-org-config-success' as const,
  payload: {
    integrationSlug,
    config,
    organisationId,
  },
});

export type ICreateOrgConfigFailure = ReturnType<typeof createOrgConfigFailure>;
export const createOrgConfigFailure = (
  integrationSlug: string,
  organisationId?: string,
  status?: number,
  errorCode?: string,
) => ({
  type: 'integrations/create-org-config-failure' as const,
  payload: { integrationSlug, organisationId, status, errorCode },
});

export type IEditOrgConfig = ReturnType<typeof editOrgConfig>;
export const editOrgConfig = (
  integrationSlug: string,
  isEnabled: boolean,
  configData: object,
  organisationId?: string,
) => ({
  type: 'integrations/edit-org-config' as const,
  payload: {
    integrationSlug,
    isEnabled,
    configData,
    organisationId,
  },
});

export type IEditOrgConfigSuccess = ReturnType<typeof editOrgConfigSuccess>;
export const editOrgConfigSuccess = (
  integrationSlug: string,
  config: IntegrationOrgConfig,
  organisationId?: string,
) => ({
  type: 'integrations/edit-org-config-success' as const,
  payload: {
    integrationSlug,
    config,
    organisationId,
  },
});

export type IEditOrgConfigFailure = ReturnType<typeof editOrgConfigFailure>;
export const editOrgConfigFailure = (
  integrationSlug: string,
  organisationId?: string,
  status?: number,
  errorCode?: string,
) => ({
  type: 'integrations/edit-org-config-failure' as const,
  payload: { integrationSlug, organisationId, status, errorCode },
});
